import { Head } from '@inertiajs/react'
import AppLayout from '@/components/AppLayout'
import { VersionsPage } from '@/components/screens/VersionsScreen'
import type { GameVersion } from '@/models'

interface VersionsProps {
  versions: GameVersion[]
  can_edit: boolean
}

export default function Versions({ versions, can_edit }: VersionsProps) {
  return (
    <AppLayout>
      <Head title="Versions" />
      <VersionsPage versions={versions} canEdit={can_edit} />
    </AppLayout>
  )
}
